/**
 * Validates staking amount
 */
export const validateStakingAmount = (
  amount: string,
  minDeposit: number,
  balance: number,
  poolRemaining: number
): { isValid: boolean; error: string | null } => {
  const amountNum = parseFloat(amount);

  if (isNaN(amountNum) || amountNum <= 0) {
    return { isValid: false, error: 'Please enter a valid amount' };
  }

  if (amountNum < minDeposit) {
    return { isValid: false, error: `Minimum amount is ${minDeposit}` };
  }

  if (amountNum > balance) {
    return { isValid: false, error: 'Insufficient balance' };
  }

  if (amountNum > poolRemaining) {
    return { isValid: false, error: `Maximum available is ${poolRemaining}` };
  }

  return { isValid: true, error: null };
};

/**
 * Calculates estimated returns
 */
export const calculateEstimatedReturns = (
  amount: string,
  apy: number,
  periodDays: string
): { daily: number; total: number } => {
  const amountNum = parseFloat(amount) || 0;
  const days = periodDays === '0' ? 1 : parseInt(periodDays);

  const daily = (amountNum * apy) / 365 / 100;
  const total = periodDays === '0' ? daily : (amountNum * apy * days) / 365 / 100;

  return { daily, total };
};
